import { getPipelineSteps } from '@lib/api'
import { pipelineStepsKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const usePipelineSteps = () => {
  return useQuery(pipelineStepsKeys.all, () => getPipelineSteps())
}
